import type { MessageKey } from './en';

/** हिन्दी — complete; any future key falls back to English. */
export const hi: Partial<Record<MessageKey, string>> = {
  'app.tagline': 'कॉल ब्रेक · तीन पत्ती · पोकर · मैरिज',
  'common.continue': 'जारी रखें',
  'common.back': 'वापस',
  'common.cancel': 'रद्द करें',
  'common.close': 'बंद करें',
  'common.save': 'सेव करें',
  'common.retry': 'फिर से कोशिश करें',
  'common.loading': 'लोड हो रहा है…',
  'common.done': 'हो गया',
  'common.skip': 'छोड़ें',
  'common.coins': 'सिक्के',
  'common.online': '{n} ऑनलाइन',
  'common.copy': 'कॉपी',
  'common.copied': 'कॉपी हो गया!',
  'common.share': 'शेयर',
  'common.level': 'लेवल {n}',
  'common.claim': 'लें',
  'common.claimed': 'ले लिया',
  'common.seeAll': 'सब देखें',
  'error.generic': 'कुछ गलत हो गया। फिर से कोशिश करें।',
  'error.network': 'सर्वर तक नहीं पहुँच पाए। कनेक्शन जाँचें।',
  'error.offline': 'आप ऑफ़लाइन हैं। हम अपने आप फिर जुड़ेंगे।',
  'error.reconnecting': 'कनेक्शन टूट गया। हम आपको फिर से जोड़ रहे हैं…',
  'error.maintenance': 'छोटा अपग्रेड चल रहा है। कुछ मिनट बाद कोशिश करें।',
  'nav.home': 'होम',
  'nav.play': 'खेलें',
  'nav.friends': 'दोस्त',
  'nav.ranks': 'रैंक',
  'nav.profile': 'प्रोफ़ाइल',
  'onboard.welcome.title': 'कभी भी ताश की महफ़िल।',
  'onboard.welcome.body': 'दोस्तों के साथ अपने पसंदीदा ताश के खेल खेलें। मुफ़्त सिक्के, असली पैसा नहीं।',
  'onboard.welcome.cta': 'शुरू करें',
  'onboard.welcome.login': 'मेरा खाता पहले से है',
  'onboard.username.title': 'खिलाड़ी का नाम चुनें',
  'onboard.avatar.title': 'अपना अवतार चुनें',
  'onboard.signup.title': 'अपना खाता सुरक्षित करें',
  'onboard.bonus.title': 'स्वागत उपहार!',
  'onboard.bonus.body': 'आपके वॉलेट में {amount} सिक्के जोड़ दिए गए हैं।',
  'onboard.favorite.title': 'आपको क्या खेलना पसंद है?',
  'onboard.tutorial.title': 'छोटा ट्यूटोरियल?',
  'onboard.tutorial.yes': 'सिखाइए',
  'onboard.tutorial.no': 'अभी खेलें',
  'auth.login': 'साइन इन',
  'auth.guest': 'अतिथि के रूप में जारी रखें',
  'onboard.welcome.games': '{n} कार्ड गेम',
  'onboard.welcome.perkCoins': 'मुफ़्त सिक्के',
  'onboard.welcome.perkBots': 'बॉट्स के साथ अभ्यास',
  'auth.register': 'खाता बनाएँ',
  'auth.username': 'यूज़रनेम',
  'auth.password': 'पासवर्ड',
  'auth.logout': 'साइन आउट',
  'lobby.quickPlay': 'क्विक प्ले',
  'lobby.privateRoom': 'प्राइवेट रूम',
  'lobby.daily': 'डेली',
  'lobby.missions': 'मिशन',
  'lobby.store': 'स्टोर',
  'lobby.watchAd': 'मुफ़्त सिक्के',
  'lobby.games': 'गेम्स',
  'lobby.recent': 'हाल के गेम',
  'games.search': 'खेल खोजें',
  'games.clear': 'खोज साफ़ करें',
  'games.noMatch': '"{q}" से कोई खेल नहीं मिला',
  'games.results': '{n} खेल मिले',
  'games.favourites': 'पसंदीदा',
  'games.recentlyPlayed': 'हाल में खेले',
  'games.all': 'सभी खेल',
  'games.favAdd': '{game} को पसंदीदा में जोड़ें',
  'games.favRemove': '{game} को पसंदीदा से हटाएँ',
  'lobby.rejoin': 'फिर से जुड़ें',
  'lobby.joinRoom': 'कोड से जुड़ें',
  'lobby.howToPlay': 'कैसे खेलें',
  'game.CALL_BREAK': 'कॉल ब्रेक',
  'game.SPADES': 'स्पेड्स',
  'game.TARNEEB': 'तरनीब',
  'game.HEARTS': 'हार्ट्स',
  'game.FIVE_HUNDRED': 'फाइव हंड्रेड',
  'game.JUDGEMENT': 'जजमेंट',
  'game.RUMMY': 'रमी',
  'game.EUCHRE': 'यूकर',
  'game.GIN_RUMMY': 'जिन रमी',
  'game.TWENTY_NINE': 'ट्वेंटी-नाइन (29)',
  'game.CRAZY_EIGHTS': 'क्रेज़ी एट्स',
  'game.CRIBBAGE': 'क्रिबेज',
  'game.BLACKJACK': 'ब्लैकजैक',
  'game.BHABHI': 'भाभी (थुल्ला)',
  'game.PINOCHLE': 'पिनोकल',
  'game.ANDAR_BAHAR': 'अंदर बाहर',
  'game.BRIDGE': 'ब्रिज',
  'game.SEVENS': 'सत्ते पे सत्ता',
  'game.SCOPA': 'स्कोपा',
  'game.BACCARAT': 'बैकारा',
  'game.BLUFF': 'ब्लफ़ (चीट)',
  'game.DRAGON_TIGER': 'ड्रैगन टाइगर',
  'game.FLUSH': 'फ्लश',
  'game.COURT_PIECE': 'कोर्ट पीस',
  'game.DEHLA_PAKAD': 'दहला पकड़',
  'dp.firstFive': 'पहले पाँच पत्तों से तुरुप चुनें',
  'dp.outcome.KOT': 'कोट! एक टीम ने सभी 13 चालें जीतीं',
  'dp.outcome.MENDICOT': 'मेंडीकोट — एक टीम ने चारों दहले जीते',
  'dp.outcome.TENS': 'तीन दहले हाथ तय करते हैं',
  'dp.outcome.TRICKS': 'दहले 2–2 बँटे — ज़्यादा चालें जीतने वाली टीम जीती',
  'dp.scoreHint': '{target} अंक तक पहुँचने वाली पहली टीम जीतती है। चार दहले इनाम हैं: तीन दहले पर 1 अंक, चारों (मेंडीकोट) पर 2, दहले 2–2 बँटें तो ज़्यादा चालें जीतने वाली टीम को 1, और सभी 13 चालें (कोट) जीतने पर 3 अंक।',
  'wh.hand': 'हाथ {n}',
  'wh.trump': 'तुरुप',
  'wh.dealerHolds': '{name} के पास पलटा हुआ पत्ता है',
  'wh.tricks': '{n} चालें',
  'wh.handScores': 'हाथ {n} का स्कोर',
  'wh.scoreHint': '{target} अंक पर पहुँचने वाली पहली जोड़ी जीतती है। केवल छह से ऊपर की चालें गिनी जाती हैं।',
  'cnt.hand': 'हैंड {n}',
  'cnt.stock': 'स्टॉक {n}',
  'cnt.pile': 'ढेर ({n})',
  'cnt.frozen': 'फ्रोज़न',
  'cnt.draw': '2 उठाएँ',
  'cnt.take': 'ढेर लें',
  'cnt.meld': 'मेल्ड',
  'cnt.discard': 'फेंकें',
  'cnt.clear': 'हटाएँ',
  'cnt.ourMelds': 'हमारे मेल्ड',
  'cnt.theirMelds': 'उनके मेल्ड',
  'cnt.canasta': 'कैनास्टा',
  'cnt.noMeld': 'अभी नहीं',
  'cnt.need': 'पहले मेल्ड के लिए {n}+ अंक चाहिए',
  'cnt.pickRank': 'वाइल्ड कार्ड किस मेल्ड में जोड़ें?',
  'cnt.wildNeedRank': 'वाइल्ड कार्ड के साथ एक ही रैंक के असली कार्ड चुनें',
  'cnt.wentOut': '{name} बाहर हो गए',
  'cnt.stockOut': 'स्टॉक खत्म हो गया',
  'cnt.scoreHint': '{target} अंक पर पहुँचने वाली पहली जोड़ी जीतती है। हर खाना: मेल्ड + कैनास्टा + लाल तीन + आउट बोनस − बचे पत्ते।',
  'r5.hand': 'हाथ {n}',
  'r5.stock': 'स्टॉक {n}',
  'r5.pile': 'डिस्कार्ड पाइल ({n})',
  'r5.tapPile': 'उभरे हुए पत्ते को छुएँ — उसके ऊपर के पत्ते भी आएँगे',
  'r5.draw': 'उठाएँ',
  'r5.meldBtn': 'मेल्ड',
  'r5.discard': 'फेंकें',
  'r5.clear': 'हटाएँ',
  'r5.melds': 'मेज़ पर मेल्ड',
  'r5.noMelds': 'अभी कोई मेल्ड नहीं',
  'r5.meld': 'मेल्ड',
  'r5.you': 'आप',
  'r5.wentOut': '{name} बाहर हुआ',
  'r5.stockOut': 'स्टॉक खत्म हो गया',
  'r5.layoffHint': 'हाथ से एक पत्ता चुनें, फिर मेल्ड पर छुएँ',
  'r5.noFit': 'यह पत्ता इस मेल्ड में नहीं बैठता',
  'r5.mustUse': 'इस बार उठाया {card} इस्तेमाल करें',
  'r5.scoreHint': '{target} अंक पर पहुँचने वाला जीतता है। मेल्ड के पत्ते आपके अंक बढ़ाते हैं, हाथ में बचे पत्ते घटाते हैं।',
  'be.hand': 'हाथ {n}',
  'be.round1': 'बोली: पत्ता लें?',
  'be.round2': 'बोली: तुरुप बताएँ',
  'be.upCard': 'पलटा हुआ पत्ता',
  'be.take': 'लें',
  'be.taker': 'लेने वाला',
  'be.belote': 'बेलोट',
  'be.capot': 'कैपो',
  'be.bid': 'बोली',
  'be.takeUp': 'पलटे पत्ते की रंग तुरुप लें?',
  'be.nameTrump': 'तुरुप का रंग बताएँ या पास करें',
  'be.chooseSuit': 'तुरुप का रंग चुनें',
  'be.handScores': 'हाथ {n} के अंक',
  'be.failed': '{name} की जोड़ी अनुबंध से चूक गई',
  'be.scoreHint': '{target} अंक पर पहुँचने वाली पहली जोड़ी जीतती है। लेने वाले को विरोधियों से अधिक अंक चाहिए; बेलोट-रीबेलोट 20 और कैपो 90 जोड़ता है।',
  'pch.hand': 'हाथ {n}',
  'pch.bidN': 'बोली {n}',
  'pch.bidder': 'बोली लगाने वाला',
  'pch.bid': 'आपकी बोली',
  'pch.toBid': 'बोली लगाएँ या पास',
  'pch.stuck': 'सबने पास किया: आपको 2 की बोली लेनी है',
  'pch.sets': 'पहला पत्ता तुरुप तय करता है',
  'pch.bidsInfo': '{name} ने {n} की बोली लगाई',
  'pch.handScores': 'हाथ {n} के अंक',
  'pch.setBack': '{name} की जोड़ी {n} अंक पीछे गई',
  'pch.high': 'हाई',
  'pch.low': 'लो',
  'pch.jack': 'जैक',
  'pch.game': 'गेम',
  'pch.scoreHint': '{target} अंक पर पहुँचने वाली पहली जोड़ी जीतती है। हाई, लो, जैक और गेम जीतें: बोली लगाने वालों को अपनी बोली पूरी करनी होगी वरना अंक कटेंगे।',
  'pch.pitchIt': 'कोई भी पत्ता चलें: उसका रंग तुरुप बनेगा',
  'pch.bidWas': 'बोली {n}',
  'bsc.stock': '{n} बाकी',
  'bsc.trumpCard': 'तुरुप का पत्ता',
  'bsc.pts': 'अंक',
  'bsc.won': 'जीते',
  'bsc.handWon': 'हाथ जीता',
  'bsc.drawn': '60–60 बराबर — दोबारा बँटेगा',
  'bsc.scoreHint': '120 में से 60 से अधिक अंक पर हाथ जीता जाता है। {target} हाथ जीतने वाली पहली जोड़ी मैच जीतती है।',
  'trs.pts': 'अंक',
  'trs.target': 'पहले {n} तक',
  'trs.thisHand': 'इस हाथ में',
  'trs.scoreHint': 'इक्का 1 अंक का है और 3, 2, K, Q, J एक-एक तिहाई अंक के; आख़िरी ट्रिक पर 1 अंक मिलता है। हर हाथ पूरे अंकों में नीचे की ओर गोल होता है। {target} अंक तक पहुँचने वाली पहली जोड़ी मैच जीतती है।',
  'game.WHIST': 'विस्ट',
  'game.SEEP': 'सीप',
  'game.BELOTE': 'बेलोट',
  'game.DURAK': 'दुरक',
  'du.cards': '{n} पत्ते',
  'du.out': 'बाहर · {n}',
  'du.attacker': 'हमलावर',
  'du.defender': 'रक्षक',
  'du.durakTag': 'दुरक',
  'du.bout': 'दौर {n}',
  'du.stock': 'गड्डी {n}',
  'du.trump': 'तुरुप',
  'du.trumpCard': 'तुरुप का पत्ता',
  'du.defendHint': 'ऊँचे पत्ते या {trump} तुरुप से काटें — या उठा लें',
  'du.cannotBeat': 'आप इसे नहीं काट सकते — पत्ते उठाएँ',
  'du.leadHint': 'कोई भी पत्ता चलें',
  'du.pileOnHint': 'वे उठा रहे हैं — उसी वर्ग का पत्ता डालें या पास करें',
  'du.throwHint': 'उसी वर्ग का पत्ता डालें या पास करें',
  'du.took': '{name} ने पत्ते उठाए',
  'du.beaten': 'काट दिया — अब {name} हमला करेगा',
  'du.taking': '{name} पत्ते उठा रहा है',
  'du.noDurak': 'सब बाहर हो गए — कोई दुरक नहीं!',
  'du.isDurak': '{name} दुरक है!',
  'du.take': 'पत्ते उठाएँ',
  'du.pass': 'पास',
  'du.player': 'खिलाड़ी',
  'du.cardsLeft': 'बचे पत्ते',
  'du.outShort': 'बाहर',
  'du.scoreHint': 'हर हमले को उसी रंग के ऊँचे पत्ते या तुरुप से काटें, या पत्ते उठा लें। बाकी खिलाड़ी मेज़ पर मौजूद वर्ग के पत्ते डाल सकते हैं। हर दौर के बाद सब छह तक भरते हैं। गड्डी खत्म होने पर बिना पत्तों वाले खिलाड़ी बाहर हो जाते हैं — आखिर में पत्ते वाला खिलाड़ी दुरक है।',
  'game.PRESIDENT': 'प्रेसिडेंट',
  'game.BRISCOLA': 'ब्रिस्कोला',
  'game.CASINO_WAR': 'कैसीनो वॉर',
  'game.THREE_CARD_POKER': 'थ्री कार्ड पोकर',
  'game.GO_FISH': 'गो फिश',
  'game.TRESSETTE': 'ट्रेसेट',
  'game.RED_DOG': 'रेड डॉग',
  'game.CANASTA': 'कैनास्टा',
  'game.SKAT': 'स्कैट',
  'skt.deal': 'डील {n}',
  'skt.bid': 'बोली',
  'skt.playing': 'खेल',
  'skt.skat': 'स्कैट',
  'skt.skatTaken': 'स्कैट उठाया',
  'skt.holds': 'होल्ड',
  'skt.declarer': 'डिक्लेयरर',
  'skt.cardPts': '{n} अंक',
  'skt.bidding': '{name} बोली लगा रहे हैं',
  'skt.looking': '{name} स्कैट देख रहे हैं',
  'skt.choosing': '{name} खेल चुन रहे हैं',
  'skt.redealt': 'सबने पास किया, इसलिए पत्ते दोबारा बाँटे गए',
  'skt.handScores': 'डील {n} का नतीजा',
  'skt.won': '{name} जीते',
  'skt.lost': '{name} हारे',
  'skt.declarerPoints': '{n} कार्ड अंक',
  'skt.with': '{n} के साथ',
  'skt.without': '{n} के बिना',
  'skt.schneider': 'श्नाइडर',
  'skt.schwarz': 'श्वार्ज़',
  'skt.overbid': 'ज़्यादा बोली: खेल की कीमत {value} थी, बोली {bid} से कम।',
  'skt.bidTitle': 'आपकी बोली',
  'skt.forehandTitle': 'सबने पास किया। 18 पर खेलें?',
  'skt.current': 'मौजूदा बोली {n}',
  'skt.more': 'और बोलियाँ',
  'skt.respondTitle': 'होल्ड या पास?',
  'skt.hold': '{n} होल्ड करें',
  'skt.youWon': 'आपने {n} पर बोली जीती',
  'skt.skatHint': 'स्कैट के दो पत्ते उठाएँ, फिर दो पत्ते हटाएँ और खेल चुनें।',
  'skt.pickup': 'स्कैट उठाएँ',
  'skt.declareTitle': 'दो पत्ते हटाएँ, फिर खेल चुनें',
  'skt.discardCount': '2 में से {n} चुने',
  'skt.chooseGame': 'खेल',
  'skt.worth': 'कीमत {value} (आधार {base})',
  'skt.worthLess': 'कीमत सिर्फ़ {value}, आपकी बोली {bid} से कम। आप हार जाएँगे।',
  'skt.confirm': '{game} खेलें',
  'skt.game.C': 'चिड़ी',
  'skt.game.S': 'हुकुम',
  'skt.game.H': 'पान',
  'skt.game.D': 'ईंट',
  'skt.game.GRAND': 'ग्रैंड',
  'skt.game.NULL': 'नल',
  'skt.scoreHint': '{target} अंक तक पहले पहुँचने वाला जीतता है। सिर्फ़ डिक्लेयरर के अंक बनते हैं: जीत पर खेल की कीमत, हार पर उसका दोगुना घटता है।',
  'game.PAI_GOW': 'पाई गॉ पोकर',
  'game.BIG_TWO': 'बिग टू',
  'bt.cards': '{n} पत्ते',
  'bt.out': 'बाहर · {n}',
  'bt.first': 'पहला',
  'bt.second': 'दूसरा',
  'bt.third': 'तीसरा',
  'bt.last': 'आख़िरी',
  'bt.leadHint': 'आपकी बारी — एक पत्ता, जोड़ी, तीन एक जैसे या पाँच पत्तों का हाथ चलें',
  'bt.openHint': 'आप शुरू करें — पहली चाल में ♦3 ज़रूर हो',
  'bt.followHint': '{n} बड़े पत्तों से काटें — या पास करें',
  'bt.passed': 'पास',
  'bt.play': 'चलें',
  'bt.pass': 'पास',
  'bt.pile': 'ढेर {n}',
  'bt.empty': 'कोई भी संयोजन चलें',
  'bt.player': 'खिलाड़ी',
  'bt.cardsLeft': 'बचे पत्ते',
  'bt.outShort': 'बाहर',
  'bt.clearedPasses': 'सबने पास किया — {name} शुरू करेगा',
  'bt.isLast': '{name} आख़िरी है',
  'bt.scoreHint': 'सबसे पहले अपने सारे पत्ते चलें। पिछली चाल जितने ही पत्तों से उसे काटें, या पास करें। दुक्की सबसे बड़ी है; हुकुम पान, चिड़ी और ईंट से बड़ा है।',
  'bt.single': 'एक पत्ता',
  'bt.pair': 'जोड़ी',
  'bt.triple': 'तीन एक जैसे',
  'bt.straight': 'सीक्वेंस',
  'bt.flush': 'फ्लश',
  'bt.fullhouse': 'फुल हाउस',
  'bt.four': 'चार एक जैसे',
  'bt.straightflush': 'स्ट्रेट फ्लश',
  'bt.selectHint': 'चाल बनाने के लिए पत्ते चुनें, फिर चलें दबाएँ',
  'game.WAR': 'वॉर',
  'game.RUMMY_500': 'रमी 500',
  'game.BRAG': 'थ्री कार्ड ब्रैग',
  'game.PITCH': 'पिच',
  'game.HAZARI': 'हज़ारी',
  'sp.bid': 'अपनी चालें बोलें',
  'sp.yourBid': 'आपकी बोली',
  'sp.bidValue': 'बोली {n}',
  'sp.bidNil': 'निल बोलें',
  'sp.nil': 'निल',
  'sp.nilLong': 'निल (कोई चाल नहीं जीतना)',
  'sp.round': 'राउंड {n}',
  'sp.broken': 'स्पेड्स खुल गए',
  'sp.partner': 'साथी',
  'sp.us': 'हम',
  'sp.them': 'वे',
  'sp.bags': '{n} बैग',
  'sp.bagsWord': 'बैग',
  'sp.roundScores': 'राउंड {n} का स्कोर',
  'sp.scoreHint': '{target} तक पहुँचने वाली टीम जीतती है; {lose} पर पहुँची टीम हार जाती है। हर 10 बैग पर 100 अंक कटते हैं।',
  'ta.bid': 'अपनी चालें बोलें',
  'ta.yourBid': 'आपकी बोली',
  'ta.pass': 'पास',
  'ta.bidTag': 'बोली {n}',
  'ta.trump': 'तुरुप',
  'ta.choosing': '{name} तुरुप चुन रहे हैं',
  'ta.passHint': '7 या अधिक बोलें, या पास करें',
  'ta.mustBid': 'सबने पास किया — आपको बोली लगानी होगी',
  'ta.chooseTrump': 'तुरुप चुनें',
  'ta.scoreHint': '{target} तक पहुँचने वाली टीम जीतती है। बोली पूरी होने पर जीती हुई चालों के अंक मिलते हैं (13 पर 16); चूकने पर बोली के अंक कटते हैं। बचाव करने वाली टीम को अपनी चालों के अंक मिलते हैं।',
  'cp.caller': 'कॉलर',
  'cp.scoreHint': '{target} कोर्ट जीतने वाली टीम जीतती है। 13 में से 7 या अधिक चालें जीतने पर कोर्ट मिलता है; सभी 13 जीतने पर 2 कोर्ट। कॉलर पाँच पत्ते देखकर रंग (तुरुप) चुनता है और टीम जीतने तक भूमिका बनाए रखता है।',
  'hr.dir.left': 'बाएँ वाले',
  'hr.dir.right': 'दाएँ वाले',
  'hr.dir.across': 'सामने वाले',
  'hr.dir.hold': 'किसी',
  'hr.passTitle': '3 पत्ते {dir} को दें',
  'hr.noPass': 'इस राउंड में पत्ते नहीं दिए जाते',
  'hr.pickThree': '{n}/3 चुने गए',
  'hr.passBtn': 'पत्ते दें',
  'hr.passed': 'दे दिए',
  'hz.pts': 'अंक',
  'hz.hand': 'हाथ {n}',
  'hz.handScores': 'हाथ {n} के अंक',
  'hz.leadHint': 'आपकी चाल — कोई भी पत्ता खेलें',
  'hz.won': '{name} को {n} अंक मिले',
  'hz.scoreHint': 'सबसे ज़्यादा अंक वाला जीतता है। मैच तब खत्म होता है जब कोई खिलाड़ी सबसे ऊपर रहकर {target} तक पहुँचे, या {max} हाथों के बाद। हर चाल में पत्तों के अंक: इक्का 11, दहला 10, बादशाह 4, बेगम 3, गुलाम 2, और आखिरी चाल के 10 और।',
  'hr.broken': 'हार्ट्स खुल गए',
  'hr.received': 'आपको मिले',
  'hr.moon': '{name} ने चाँद शूट किया!',
  'hr.scoreHint': 'सबसे कम स्कोर वाला जीतता है। किसी खिलाड़ी के {target} तक पहुँचते ही खेल खत्म होता है। हर हार्ट 1 अंक और हुकुम की बेगम 13 अंक की है; सारे 26 अंक लेना चाँद शूट करना है।',
  'fh.bid': 'अपनी बोली लगाएँ',
  'fh.yourBid': 'आपकी बोली',
  'fh.contract': 'कॉन्ट्रैक्ट',
  'fh.choosingDiscard': '{name} पत्ते फेंक रहे हैं',
  'fh.discardTitle': '3 पत्ते फेंकें',
  'fh.discardBtn': 'पत्ते फेंकें',
  'fh.nameSuit': 'जोकर के लिए रंग बताएँ',
  'fh.follow': '{suit} डालें',
  'fh.made': 'पूरा हुआ',
  'fh.failed': 'चूक गए',
  'fh.scoreHint': '{target} तक पहुँचने वाली टीम जीतती है; -{target} पर पहुँची टीम हार जाती है। पूरी हुई बोली का मूल्य मिलता है (10 चालों पर कम से कम 250), चूकने पर वही कटता है, और दूसरी टीम को हर चाल के 10 अंक मिलते हैं।',
  'ju.bid': 'अपनी चालों की बोली लगाएँ',
  'ju.yourBid': 'आपकी बोली',
  'ju.bidValue': '{n} की बोली',
  'ju.round': 'राउंड {n}/{total}',
  'ju.card': '1 पत्ता',
  'ju.cards': '{n} पत्ते',
  'ju.trump': 'तुरुप',
  'ju.trumpCard': 'तुरुप का पत्ता',
  'ju.hook': 'डीलर होने के नाते आप {n} की बोली नहीं लगा सकते — बोलियों का जोड़ चालों के बराबर नहीं हो सकता।',
  'ju.scoreHint': 'जितनी चालों की बोली लगाई, ठीक उतनी जीतें तो 10 और आपकी बोली के अंक मिलते हैं; चूके तो चूक के बराबर अंक कटते हैं। हर राउंड में पत्तों की संख्या बदलती है और सबसे ज़्यादा कुल अंक वाला जीतता है।',
  'ru.deal': 'डील {n}/{total}',
  'ru.wild': 'जोकर: {rank}',
  'ru.cutJoker': 'कट जोकर',
  'ru.points': 'अंक: {n}',
  'ru.dropped': 'ड्रॉप',
  'ru.drop': 'ड्रॉप',
  'ru.dropTitle': 'यह डील ड्रॉप करें?',
  'ru.dropBody': 'आप इस डील से बाहर हो जाएँगे और {n} अंक लेंगे।',
  'ru.declare': 'डिक्लेयर',
  'ru.declareTitle': 'अपना हाथ डिक्लेयर करें',
  'ru.declareBody': '{card} फेंकें और ये समूह दिखाएँ।',
  'ru.notReady': 'अभी जीतने वाला हाथ नहीं है: एक प्योर सीक्वेंस, दूसरी सीक्वेंस और बाकी सब पत्ते सीक्वेंस या सेट में चाहिए।',
  'ru.winner': '{name} ने डिक्लेयर किया!',
  'ru.lastPlayer': '{name} जीते — बाकी सब ने ड्रॉप किया',
  'ru.stockOut': 'स्टॉक खत्म हो गया — कोई विजेता नहीं',
  'ru.scoreHint': 'सबसे कम कुल अंक वाला जीतता है। डील जीतने वाले के 0 अंक; बाकी सबके बिना जमे पत्तों के अंक (A/K/Q/J/10 = 10, जोकर 0), ज़्यादा से ज़्यादा {max}। पहली बार खींचने से पहले ड्रॉप पर 20 और बाद में 40 अंक लगते हैं।',
  'eu.bid': 'आपकी बोली',
  'eu.call': 'तुरुप बताएँ',
  'eu.orderUp': 'ऑर्डर अप',
  'eu.orderedUp': 'ऑर्डर अप किया',
  'eu.called': 'बोला',
  'eu.alone': 'अकेले खेलें',
  'eu.callSuit': '{suit} बोलें',
  'eu.round1Hint': '{suit} को तुरुप बनाने के लिए ऑर्डर अप करें, या पास',
  'eu.round2Hint': 'कोई दूसरा रंग बताएँ, या पास',
  'eu.mustCall': 'सबने पास किया — आपको तुरुप बतानी होगी',
  'eu.turnedUp': 'खुला पत्ता',
  'eu.turnedDown': 'उलटा · {suit} नहीं',
  'eu.discardTitle': 'एक पत्ता फेंकें',
  'eu.pickUp': 'आपने {card} उठाया',
  'eu.discard': 'पत्ता चुनें',
  'eu.discardCard': '{card} फेंकें',
  'eu.waitingDiscard': '{name} पत्ता फेंक रहे हैं',
  'eu.maker': 'मेकर',
  'eu.sitting': 'बाहर बैठे',
  'eu.euchred': 'यूकर्ड',
  'eu.scoreHint': '{target} तक पहुँचने वाली टीम जीतती है। मेकर 3 या 4 चालें जीतें तो 1 अंक, सभी 5 पर 2 अंक (अकेले खेलने पर 4); कम चालें जीतें तो वे यूकर्ड हो जाते हैं और दूसरी टीम को 2 अंक मिलते हैं।',
  'gr.hand': 'हाथ {n}',
  'gr.goal': '{n} तक',
  'gr.wins': '{n} जीते',
  'gr.upcard': 'खुला पत्ता',
  'gr.take': 'खुला पत्ता लें',
  'gr.pass': 'पास',
  'gr.stockOnly': 'दोनों ने पास किया — स्टॉक से खींचें',
  'gr.knock': 'नॉक',
  'gr.gin': 'जिन!',
  'gr.deadwood': 'डेडवुड: {n}',
  'gr.deadwoodLabel': 'डेडवुड',
  'gr.knocked': '{name} ने नॉक करके हाथ जीता',
  'gr.ginned': '{name} ने जिन बनाया!',
  'gr.undercut': '{name} ने नॉक को अंडरकट किया!',
  'gr.undercutShort': 'अंडरकट',
  'gr.drawHand': 'हाथ ड्रॉ — किसी को अंक नहीं',
  'gr.scoreHint': '{target} तक पहुँचने वाला जीतता है। 10 या कम डेडवुड पर नॉक करें: अंतर के अंक मिलते हैं। जिन पर 25 और उनका डेडवुड; अंडरकट पर अंतर और 25। विजेता को 100 और हर जीते हाथ पर 25 और मिलते हैं।',
  'tn.bid': 'अपने अंक बोली लगाएँ',
  'tn.passHint': '{n} या अधिक की बोली लगाएँ, या पास करें',
  'tn.yourTrump': 'आपका तुरुप',
  'tn.trumpHidden': 'तुरुप छिपा है',
  'tn.trumpSecret': 'कोई माँगे तब तक गुप्त',
  'tn.reveal': 'तुरुप माँगें',
  'tn.revealHint': 'खेले गए रंग का पत्ता नहीं है — तुरुप देखने को कहें',
  'tn.asked': 'माँगा',
  'tn.scoreHint': 'पहली टीम जो +{target} तक पहुँचे जीतती है; −{target} पर हार। बोली लगाने वालों को अपनी बोली तक पत्तों के अंक (J 3, 9 2, A 1, 10 1 — कुल 28) चाहिए: पूरी हुई तो +1, नहीं तो −1। जब तक रंग न मिलने वाला खिलाड़ी तुरुप न माँगे, वह छिपा रहता है।',
  'ce.goal': '{n} तक',
  'ce.suit': 'रंग',
  'ce.lacks': 'पत्ता खींचना पड़ा — इन रंगों का पत्ता नहीं है',
  'ce.nameSuit': 'रंग चुनें',
  'ce.draw': 'पत्ता खींचें ({n}/{max})',
  'ce.out': '{name} के सारे पत्ते खत्म!',
  'ce.blocked': 'खेल रुका — {name} का हाथ सबसे कम है',
  'ce.blockedNone': 'खेल रुका — बराबरी, किसी को अंक नहीं',
  'ce.scoreHint': '{target} तक पहुँचने वाला जीतता है। पत्ते खत्म करने पर दूसरों के हाथ में बचे पत्तों के अंक मिलते हैं (आठ 50, K Q J 10 दस-दस, इक्का 1, बाकी उनके अंक)। रुके हुए खेल में सबसे कम हाथ वाला अंतर के अंक पाता है।',
  'cg.you': 'आप',
  'cg.dealer': 'डीलर',
  'cg.starter': 'स्टार्टर',
  'cg.crib': '{name} का क्रिब',
  'cg.counting': 'गिनती हो रही है…',
  'cg.nineteen': 'उन्नीस — कोई अंक नहीं',
  'cg.count': 'योग {n}',
  'cg.toCrib': 'क्रिब में भेजें ({n}/2)',
  'cg.playHint': 'पत्ता चलें — योग 31 से ऊपर नहीं जा सकता',
  'cg.r.fifteen': 'पंद्रह',
  'cg.r.thirtyone': 'इकतीस',
  'cg.r.pair': 'जोड़ी',
  'cg.r.pairRoyal': 'तीन एक जैसे',
  'cg.r.doubleRoyal': 'चार एक जैसे',
  'cg.r.run': '{n} का क्रम',
  'cg.r.lastCard': 'आखिरी पत्ता',
  'cg.r.heels': 'हिज़ हील्स',
  'cg.r.pone': 'हाथ',
  'cg.r.dealer': 'हाथ',
  'cg.r.crib': 'क्रिब',
  'cg.i.fifteen': 'पंद्रह',
  'cg.i.pair': 'जोड़ियाँ',
  'cg.i.run': 'क्रम',
  'cg.i.flush': 'फ्लश',
  'cg.i.nobs': 'नॉब्स',
  'cg.scoreHint': '{target} तक पहुँचने वाला जीतता है। अंक मिलते ही जुड़ते हैं: खेल के दौरान पंद्रह और जोड़ियाँ, फिर हाथ और डीलर का क्रिब। पंद्रह के 2, जोड़ी के 2, क्रम की लंबाई के बराबर, फ्लश के 4 या 5, और स्टार्टर के रंग के गुलाम (नॉब्स) का 1।',
  'bj.dealer': 'डीलर',
  'bj.shoe': 'शू {n}',
  'bj.hand': 'हाथ',
  'bj.bust': 'बस्ट',
  'bj.r.BLACKJACK': 'ब्लैकजैक!',
  'bj.r.WIN': 'जीत',
  'bj.r.PUSH': 'बराबरी',
  'bj.r.LOSE': 'हार',
  'bj.r.BUST': 'बस्ट',
  'bj.sitting': 'इस हाथ में नहीं',
  'bj.betting': 'दाँव लग रहे हैं…',
  'bj.placeBet': 'अपना दाँव लगाएँ',
  'bj.limits': 'न्यूनतम {min} · अधिकतम {max}',
  'bj.sitOut': 'छोड़ें',
  'bj.bet': 'दाँव {n}',
  'bj.actions': 'आपकी चाल',
  'bj.stand': 'स्टैंड',
  'bj.hit': 'हिट',
  'bj.double': 'डबल',
  'bj.split': 'स्प्लिट',
  'bj.waiting': 'खिलाड़ियों का इंतज़ार…',
  'bj.handOver': 'हाथ खत्म',
  'bj.dealerPlays': 'डीलर खेल रहा है…',
  'bj.wait': 'दूसरे खिलाड़ियों का इंतज़ार…',
  'bh.cards': '{n} पत्ते',
  'bh.out': 'बाहर · {n}',
  'bh.bhabhiTag': 'भाभी',
  'bh.voids': 'रंग नहीं निभा सका — इन रंगों का पत्ता नहीं है',
  'bh.round': 'दौर {n}',
  'bh.discarded': 'हटाए गए {n}',
  'bh.lead': 'शुरुआत',
  'bh.firstHint': 'आपके पास हुकुम का इक्का है — उसी से शुरू करें',
  'bh.leadHint': 'कोई भी पत्ता चलें',
  'bh.dumpHint': '{suit} नहीं है? कोई भी पत्ता चलें — वह ढेर उठाने वाले को मिलेगा',
  'bh.followHint': 'रंग निभाएँ: {suit}',
  'bh.pickup': '{name} ने {n} पत्ते उठाए',
  'bh.discard': 'दौर साफ़ — अगला {name} चलेगा',
  'bh.thulla': 'थुल्ला!',
  'bh.noBhabhi': 'सब बाहर हो गए — कोई भाभी नहीं!',
  'bh.isBhabhi': '{name} भाभी बन गया!',
  'bh.player': 'खिलाड़ी',
  'bh.cardsLeft': 'बचे पत्ते',
  'bh.outShort': 'बाहर',
  'bh.scoreHint': 'अपने सारे पत्ते निकालें। चले गए रंग का पत्ता चलें; सब चलें तो दौर हट जाता है और सबसे बड़ा पत्ता अगला चलता है। रंग न हो तो कोई भी पत्ता चलें — चले गए रंग का सबसे बड़ा पत्ता पूरा ढेर उठाता है। आख़िर में जिसके पास पत्ते बचें वही भाभी है।',
  'pr.cards': '{n} पत्ते',
  'pr.out': 'बाहर · {n}',
  'pr.president': 'प्रेसिडेंट',
  'pr.vice': 'वाइस प्रेसिडेंट',
  'pr.neutral': 'न्यूट्रल',
  'pr.scum': 'स्कम',
  'pr.leadHint': 'आपकी बारी — एक पत्ता या बराबर के पत्तों का सेट चलें',
  'pr.followHint': '{n} बड़े पत्तों से काटें — या पास करें',
  'pr.passed': 'पास',
  'pr.play': 'चलें',
  'pr.pass': 'पास',
  'pr.cleared': 'ढेर साफ़',
  'pr.clearedTwo': '{name} ने दुग्गी चली — ढेर साफ़',
  'pr.clearedPasses': 'सबने पास किया — {name} शुरू करेगा',
  'pr.pile': 'ढेर {n}',
  'pr.player': 'खिलाड़ी',
  'pr.cardsLeft': 'बचे पत्ते',
  'pr.outShort': 'बाहर',
  'pr.scoreHint': 'सबसे पहले सारे पत्ते निकालें। उतने ही बड़े पत्तों से ढेर काटें या पास करें; दुग्गी सबसे बड़ी है और ढेर साफ़ करती है। आख़िर में पत्ते वाला स्कम है।',
  'gf.cards': '{n} पत्ते',
  'gf.books': '{n} बुक',
  'gf.booksOf': 'बनी हुई बुक',
  'gf.stock': 'स्टॉक: {n}',
  'gf.empty': 'अभी कोई माँग नहीं',
  'gf.pickHint': 'अपना पत्ता चुनकर रैंक तय करें, फिर खिलाड़ी चुनें',
  'gf.askHint': '{rank} माँगें — खिलाड़ी चुनें',
  'gf.ask': '{name} से माँगें',
  'gf.logHit': '{a} ने {b} से {n} × {rank} लिए',
  'gf.logMiss': '{a} ने {b} से {rank} माँगा — गो फिश!',
  'gf.logLuck': '{a} को {rank} मिल गया — फिर से!',
  'gf.logNoLuck': '{a} ने {b} से {rank} माँगा — नहीं मिला',
  'gf.wins': '{name} {n} बुक के साथ जीते',
  'gf.player': 'खिलाड़ी',
  'gf.booksCol': 'बुक',
  'gf.cardsCol': 'पत्ते',
  'gf.scoreHint': 'जो रैंक आपके पास है वह किसी खिलाड़ी से माँगें। मिला तो फिर माँगें, नहीं तो गो फिश। एक रैंक के चार पत्ते = एक बुक — सबसे ज़्यादा बुक वाला जीतता है।',
  'wr.cards': '{n} पत्ते',
  'wr.rounds': '{n} जीते',
  'wr.round': 'राउंड {n} / {max}',
  'wr.table': 'मेज़',
  'wr.laid': 'उल्टे पत्ते: आप {a} · विरोधी {b}',
  'wr.raised': '{name} ने बढ़ाया',
  'wr.stayed': 'कोई बढ़ोतरी नहीं',
  'wr.flip': 'पत्ता पलटें',
  'wr.stay': 'रुकें',
  'wr.raise': '+1 पत्ता बढ़ाएँ',
  'wr.player': 'खिलाड़ी',
  'wr.cardsCol': 'पत्ते',
  'wr.roundsCol': 'जीते राउंड',
  'wr.scoreHint': 'हर राउंड एक पत्ता पलटें; बड़ा पत्ता दोनों ले जाता है। बराबरी पर युद्ध: रुकें या बढ़ाएँ, उल्टे पत्ते रखें और फिर पलटें। {max} राउंड बाद ज़्यादा पत्तों वाला जीतता है।',
  'wr.over': '{name} मैच जीता',
  'wr.war': 'युद्ध! मेज़ पर {n} पत्ते',
  'wr.roundWon': '{name} ने {n} पत्ते लिए',
  'wr.yourFlip': 'आपकी बारी',
  'wr.waiting': '{name} का इंतज़ार',
  'pr.empty': 'कोई भी पत्ता या सेट चलें',
  'pr.isScum': '{name} स्कम है',
  'pr.selectHint': 'एक ही नंबर के पत्ते चुनें, फिर चलें दबाएँ',
  'pn.noMeld': 'कोई मेल्ड नहीं',
  'pn.meld': 'मेल्ड',
  'pn.noTrick': 'कोई दाँव नहीं',
  'pn.passing': '{name} पत्ते दे रहा है',
  'pn.passTitle': 'पत्ते दें',
  'pn.passToDeclarer': 'अपने 3 सबसे अच्छे पत्ते घोषणाकर्ता को दें',
  'pn.passToPartner': '3 पत्ते अपने साथी को लौटाएँ',
  'pn.pick': '{n}/3 चुने',
  'pn.passBtn': '3 पत्ते दें',
  'pn.bid': 'अपने अंकों की बोली',
  'pn.passHint': '{n} या अधिक की बोली लगाएँ, या पास',
  'pn.scoreHint': '{target} तक पहुँचने वाली पहली टीम जीतती है। टीम को मेल्ड और काउंटर (इक्का, 10, बादशाह और आख़िरी दाँव — कुल 25) के अंक मिलते हैं, पर केवल तब जब उसने कोई दाँव जीता हो; बोली न पूरी करने वाली टीम अपनी बोली खो देती है। रंग निभाना और जब संभव हो तब जीतने वाले पत्ते से बड़ा पत्ता चलना ज़रूरी है; रंग न हो तो तुरुप चलना होगा।',
  'ab.andar': 'अंदर',
  'ab.bahar': 'बाहर',
  'ab.joker': 'जोकर',
  'ab.pays': 'भुगतान {n}:1',
  'ab.noCards': 'पत्ते बँटने का इंतज़ार',
  'ab.noBets': 'कोई दाँव नहीं',
  'ab.side': 'एक तरफ़ चुनें',
  'ab.bet': '{side} पर {n} का दाँव',
  'ab.wins': '{side} की जीत!',
  'ab.youWon': 'आपने {n} जीते',
  'ab.youLost': 'आपने {n} गँवाए',
  'ab.dealing': 'पत्ते बँट रहे हैं…',
  'ab.yourBet': 'आपका दाँव: {side} पर {n}',
  'br.declarer': 'डिक्लेयरर',
  'br.dummy': 'डमी',
  'br.vul': 'वल्नरेबल',
  'br.deal': 'दौर {n}/{total}',
  'br.by': '{name} द्वारा',
  'br.auction': 'बोली',
  'br.dealDone': 'दौर {n} पूरा',
  'br.passedOut': 'सबने पास किया — कोई अंक नहीं',
  'br.passedOutShort': 'सब पास',
  'br.dummyHand': 'डमी ({seat})',
  'br.playFromDummy': 'डमी के लिए पत्ता चुनें',
  'br.contract': 'कॉन्ट्रैक्ट',
  'br.yourCall': 'आपकी बोली',
  'br.last': 'आख़िरी बोली',
  'br.noBids': 'अभी कोई बोली नहीं',
  'br.level': 'स्तर',
  'br.strain': 'रंग',
  'br.pass': 'पास',
  'br.scoreHint': '{deals} दौर का शिकागो मैच: ज़्यादा कुल अंक वाला जीतता है। वल्नरेबिलिटी: पहले कोई नहीं, फिर डीलर की टीम दो बार, फिर दोनों। कॉन्ट्रैक्ट पूरा करने पर दाँव के अंक और बोनस (गेम 300/500, स्लैम, डबल) मिलते हैं; विफल होने पर विरोधियों को प्रति दाँव 50/100। डिक्लेयरर डमी के पत्ते भी चलता है।',
  'sv.board': 'मेज़ पर पत्ते',
  'sv.passes': 'पास की गिनती',
  'sv.passTag': 'पास {n}',
  'sv.over': 'खेल खत्म',
  'sv.startHint': 'आपके पास ईंट का 7 है — उसी से शुरू करें',
  'sv.playHint': 'चमकता हुआ पत्ता चलें',
  'sv.noPlay': 'चलने को कुछ नहीं — पास',
  'sv.scoreHint': 'सबसे पहले अपने सारे पत्ते निकालें। हर रंग को उसके 7 से शुरू करें, फिर क्रम के ठीक ऊपर या नीचे का पत्ता जोड़ें। इक्का सबसे छोटा है। चल न सकें तो पास करें। आख़िर में जिसके पास पत्ते बचें वह हारता है।',
  'sc.deck': 'गड्डी {n}',
  'sc.table': 'मेज़ पर पत्ते',
  'sc.empty': 'मेज़ खाली है',
  'sc.captured': '{card} से {n} पत्ते लिए',
  'sc.trailed': '{card} रखा',
  'sc.scopa': 'स्कोपा!',
  'sc.choose': 'आपकी चाल',
  'sc.pickCard': 'चलने के लिए पत्ता चुनें',
  'sc.trail': '{card} रखें',
  'sc.capture': 'लें',
  'sc.dealResult': 'दौर {n} के अंक',
  'sc.cards': 'पत्ते',
  'sc.diamonds': 'ईंट',
  'sc.settebello': '7♦',
  'sc.primiera': 'प्रिमिएरा',
  'sc.scopas': 'स्कोपा',
  'sc.total': 'अंक',
  'sc.scoreHint': '{target} तक पहुँचने वाली पहली टीम जीतती है। बराबर मूल्य का पत्ता या जोड़ बराबर पत्ते लेने के लिए पत्ता चलें (इक्का 1, गुलाम 8, बेगम 9, बादशाह 10); ले सकें तो लेना ज़रूरी है। मेज़ साफ़ करना स्कोपा है (1 अंक)। हर दौर में सबसे ज़्यादा पत्तों, सबसे ज़्यादा ईंट, 7♦ और सबसे अच्छे प्रिमिएरा का भी 1-1 अंक है।',
  'se.deck': 'डेक {n}',
  'se.floor': 'फ़र्श पर पत्ते',
  'se.empty': 'फ़र्श साफ़ है',
  'se.took': '{card} से {n} उठाए',
  'se.trailed': '{card} रखा',
  'se.built': '{card} से {v} का घर बनाया',
  'se.seep': 'सीप!',
  'se.choose': 'आपकी चाल',
  'se.pickCard': 'खेलने के लिए पत्ता चुनें',
  'se.trail': '{card} रखें',
  'se.take': 'उठाएँ',
  'se.build': '{v} का घर बनाएँ',
  'se.raise': 'घर को {v} करें',
  'se.house': '{v} का घर',
  'se.dealResult': 'डील {n} का स्कोर',
  'se.cards': 'पत्ते',
  'se.cardPoints': 'पत्तों के अंक',
  'se.seeps': 'सीप',
  'se.total': 'अंक',
  'se.scoreHint': '{target} तक पहुँचने वाली पहली टीम जीतती है। समान मान का फ़र्श का पत्ता या जोड़ वाले पत्ते उठाएँ (इक्का 1, गुलाम 11, बेगम 12, बादशाह 13), या 9–13 का घर बनाएँ जिसे बाद में उठा सकें। हुकुम के पत्ते अपने मान के अंक, बाकी इक्के 1 और 10♦ के 6 अंक; सीप (फ़र्श साफ़ करना) के 50 अंक।',
  'bc.player': 'प्लेयर',
  'bc.banker': 'बैंकर',
  'bc.tie': 'टाई',
  'bc.pays': 'भुगतान {n}:1',
  'bc.tieWins': 'टाई — दोनों हाथ बराबर',
  'bc.natural': 'नेचुरल',
  'bc.push': 'दाँव वापस',
  'bc.bets': 'मेज़ पर दाँव',
  'dt.dragon': 'ड्रैगन',
  'dt.tiger': 'टाइगर',
  'dt.tie': 'टाई',
  'dt.tieWins': 'टाई — दोनों पत्ते बराबर',
  'tcp.ante': 'एंटे',
  'tcp.pairPlus': 'पेयर प्लस',
  'tcp.dealer': 'डीलर',
  'tcp.yourHand': 'आपका हाथ',
  'tcp.bet': 'एंटे {n}',
  'tcp.betPP': 'एंटे {n} + पेयर प्लस {pp}',
  'tcp.play': 'खेलें {n}',
  'tcp.fold': 'फोल्ड',
  'tcp.decide': 'खेलें या फोल्ड?',
  'tcp.noQualify': 'डीलर क्वालिफाई नहीं करता',
  'tcp.dealerQualifies': 'डीलर क्वालिफाई करता है',
  'tcp.win': 'जीत',
  'tcp.lose': 'हार',
  'tcp.push': 'बराबरी',
  'tcp.folded': 'फोल्ड',
  'tcp.bonus': 'बोनस {n}',
  'tcp.ppWin': 'पेयर प्लस {n}',
  'tcp.pairPlusBet': 'पेयर प्लस साइड बेट',
  'tcp.antePlay': 'एंटे और प्ले',
  'tcp.youBet': 'एंटे {n}',
  'tcp.cat.HIGH_CARD': 'हाई कार्ड',
  'tcp.cat.PAIR': 'जोड़ी',
  'tcp.cat.FLUSH': 'फ्लश',
  'tcp.cat.STRAIGHT': 'सीक्वेंस',
  'tcp.cat.THREE_OF_A_KIND': 'तीन एक जैसे',
  'tcp.cat.STRAIGHT_FLUSH': 'शुद्ध सीक्वेंस',
  'tcp.wait': 'दूसरे खिलाड़ियों का इंतज़ार…',
  'tcp.revealing': 'डीलर पत्ते खोल रहा है…',
  'pgw.dealer': 'डीलर',
  'pgw.yourHand': 'आपके सात पत्ते',
  'pgw.pickLow': 'निचले हाथ के लिए दो पत्ते चुनें',
  'pgw.high': 'ऊँचा हाथ (5 पत्ते)',
  'pgw.low': 'निचला हाथ (2 पत्ते)',
  'pgw.foul': 'पाँच पत्तों का हाथ दो पत्तों वाले हाथ से बड़ा होना चाहिए',
  'pgw.houseWay': 'हाउस वे',
  'pgw.setHands': 'हाथ तय करें',
  'pgw.bet': 'दांव {n}',
  'pgw.youBet': 'दांव {n}',
  'pgw.isSet': 'हाथ तय',
  'pgw.wait': 'दूसरे खिलाड़ियों का इंतज़ार…',
  'pgw.revealing': 'डीलर हाथ दिखा रहा है…',
  'pgw.commission': 'कमीशन {n}',
  'pgw.highWon': 'ऊँचा हाथ जीता',
  'pgw.highLost': 'ऊँचा हाथ हारा',
  'pgw.lowWon': 'निचला हाथ जीता',
  'pgw.lowLost': 'निचला हाथ हारा',
  'pgw.cat.HIGH_CARD': 'हाई कार्ड',
  'pgw.cat.PAIR': 'जोड़ी',
  'pgw.cat.TWO_PAIR': 'दो जोड़ी',
  'pgw.cat.THREE_OF_A_KIND': 'तीन समान',
  'pgw.cat.STRAIGHT': 'सीक्वेंस',
  'pgw.cat.FLUSH': 'फ्लश',
  'pgw.cat.FULL_HOUSE': 'फुल हाउस',
  'pgw.cat.FOUR_OF_A_KIND': 'चार समान',
  'pgw.cat.STRAIGHT_FLUSH': 'स्ट्रेट फ्लश',
  'pgw.cat.ROYAL_FLUSH': 'रॉयल फ्लश',
  'pgw.cat.FIVE_ACES': 'पाँच इक्के',
  'cw.dealer': 'डीलर',
  'cw.bet': 'दाँव {n}',
  'cw.tieBet': 'टाई दाँव',
  'cw.addTieBet': '{n} का टाई दाँव जोड़ें ({p}:1)',
  'cw.yourBet': 'आपका दाँव: {n}',
  'cw.tied': 'टाई! वॉर खेलें या हार मानें?',
  'cw.war': 'वॉर खेलें (+{n})',
  'cw.surrender': 'हार मानें ({n} वापस)',
  'cw.warOn': 'वॉर! तीन पत्ते जला दिए',
  'cw.waitTie': '{name} के फ़ैसले का इंतज़ार…',
  'cw.outWin': 'आप {n} जीते',
  'cw.outWar': 'वॉर जीता: +{n}',
  'cw.outWarLost': 'वॉर हारा: −{n}',
  'cw.outSurrender': 'हार मानी: −{n}',
  'cw.warCard': 'वॉर का पत्ता',
  'cw.bets': 'खिलाड़ी',
  'rdg.spreadTitle': 'स्प्रेड',
  'rdg.thirdCard': 'तीसरा पत्ता',
  'rdg.spread': 'स्प्रेड {n} · जीत पर {p}:1',
  'rdg.consecutive': 'लगातार पत्ते — पुश',
  'rdg.pair': 'बराबर पत्ते — तीसरा पत्ता तय करेगा',
  'rdg.ante': 'अपना ऐंटी लगाएँ',
  'rdg.betAnte': 'ऐंटी {n}',
  'rdg.yourBet': 'आपका दाँव: {n}',
  'rdg.bets': 'खिलाड़ी',
  'rdg.decide': 'रेज़ करें या रुकें?',
  'rdg.decideHint': 'स्प्रेड {n} · {p}:1',
  'rdg.raiseBy': 'रेज़ राशि',
  'rdg.raise': 'रेज़ +{n}',
  'rdg.stay': 'रुकें',
  'rdg.raised': 'रेज़ किया',
  'rdg.stayed': 'रुके',
  'rdg.waitDecide': '{name} के फ़ैसले का इंतज़ार…',
  'rdg.outWin': 'आप {n} जीते',
  'rdg.outTrips': 'तीन एक जैसे! +{n}',
  'rdg.outLose': 'आप {n} हारे',
  'rdg.outPush': 'पुश — ऐंटी वापस',
  'bl.claim': 'दावा',
  'bl.pile': 'ढेर {n}',
  'bl.empty': 'खाली',
  'bl.claimed': '{name} ने {n} × {rank} रखे',
  'bl.honest': 'सच! {name} ढेर उठाता है ({n})',
  'bl.caught': 'झूठ पकड़ा गया! {name} ढेर उठाता है ({n})',
  'bl.winner': 'विजेता',
  'bl.wins': '{name} जीता!',
  'bl.call': 'ब्लफ़ बोलें!',
  'bl.accept': 'मान लें — {name} बाहर होता है',
  'bl.pick': '{rank} बताने को पत्ते चुनें',
  'bl.play': '{n} पत्ते {rank} बताकर रखें',
  'bl.scoreHint': 'जो सबसे पहले सारे पत्ते निकाल दे वह जीतता है; बाकी बचे पत्तों से क्रम पाते हैं। 1–4 पत्ते उल्टे रखकर माँगा गया दर्जा बताएँ — आप झूठ बोल सकते हैं। अगला खिलाड़ी ब्लफ़ बोल सकता है: झूठ निकला तो आप पूरा ढेर उठाते हैं, वरना वह उठाता है। जीतने के लिए आख़िरी पत्तों को भी चुनौती से बचना होगा।',
  'pn.m.run': 'क्रम',
  'pn.m.doubleRun': 'दोहरा क्रम',
  'pn.m.royal': 'शाही जोड़ी',
  'pn.m.marriage': 'जोड़ी',
  'pn.m.dix': 'डिक्स',
  'pn.m.pinochle': 'पिनोकल',
  'pn.m.doublePinochle': 'दोहरा पिनोकल',
  'pn.m.aces': 'चारों इक्के',
  'pn.m.kings': 'चारों बादशाह',
  'pn.m.queens': 'चारों बेगम',
  'pn.m.jacks': 'चारों गुलाम',
  'pn.m.doubleAces': 'दोहरे इक्के',
  'pn.m.doubleKings': 'दोहरे बादशाह',
  'pn.m.doubleQueens': 'दोहरी बेगम',
  'pn.m.doubleJacks': 'दोहरे गुलाम',
  'game.TEEN_PATTI': 'तीन पत्ती',
  'game.POKER': 'पोकर',
  'game.MARRIAGE': 'मैरिज',
  'tables.title': 'टेबल चुनें',
  'tables.entry': 'एंट्री',
  'tables.play': 'खेलें',
  'mm.searching': 'खिलाड़ी ढूँढ रहे हैं…',
  'mm.cancel': 'रद्द करें',
  'mm.matched': 'टेबल मिल गई!',
  'table.leave': 'छोड़ें',
  'table.yourTurn': 'आपकी बारी',
  'table.waitingFor': '{name} की बारी',
  'table.imBack': 'मैं वापस आ गया',
  'table.round': 'राउंड {n}/{total}',
  'cb.bid': 'अपने हाथ कॉल करें',
  'tp.see': 'पत्ते देखें',
  'tp.chaal': 'चाल {n}',
  'tp.blind': 'ब्लाइंड {n}',
  'tp.raise': 'रेज़ {n}',
  'tp.pack': 'पैक',
  'tp.show': 'शो {n}',
  'tp.sideShow': 'साइड शो {n}',
  'pk.fold': 'फ़ोल्ड',
  'pk.check': 'चेक',
  'pk.call': 'कॉल {n}',
  'pk.allIn': 'ऑल-इन',
  'mr.drawStock': 'खींचें',
  'mr.pickDiscard': 'उठाएँ',
  'mr.discard': 'फेंकें',
  'mr.show': 'शो (जोकर देखें)',
  'mr.finish': 'खेल ख़त्म करें',
  'results.title': 'नतीजे',
  'results.won': 'आपने {n} सिक्के जीते!',
  'results.lost': 'आपने {n} सिक्के हारे',
  'results.playAgain': 'फिर खेलें',
  'results.lobby': 'लॉबी',
  'rooms.create': 'प्राइवेट रूम बनाएँ',
  'rooms.invite': 'दोस्तों को बुलाएँ',
  'rooms.start': 'गेम शुरू करें',
  'friends.title': 'दोस्त',
  'friends.add': 'जोड़ें',
  'friends.accept': 'स्वीकारें',
  'friends.reject': 'मना करें',
  'profile.title': 'प्रोफ़ाइल',
  'profile.played': 'खेले',
  'profile.won': 'जीते',
  'settings.title': 'सेटिंग्स',
  'settings.language': 'भाषा',
  'settings.sound': 'साउंड',
  'settings.music': 'म्यूज़िक',
  'settings.legal': 'सिक्के वर्चुअल हैं, इनकी कोई नकद क़ीमत नहीं है और इन्हें निकाला नहीं जा सकता।',
  'daily.title': 'डेली रिवॉर्ड',
  'daily.day': 'दिन {n}',
  'daily.claim': 'रिवॉर्ड लें',
  'missions.title': 'मिशन',
  'store.title': 'सिक्का स्टोर',
  'lb.title': 'लीडरबोर्ड',
  'notif.title': 'सूचनाएँ',
  'app.name': 'Card Hub',
  'common.yes': 'हाँ',
  'common.no': 'नहीं',
  'common.free': 'मुफ़्त',
  'common.comingSoon': 'जल्द आ रहा है',
  'common.bot': 'BOT',
  'error.sessionExpired': 'आपका सत्र समाप्त हो गया। कृपया फिर से साइन इन करें।',
  'onboard.username.hint': '3–20 अक्षर, अंक या _',
  'onboard.signup.body': 'पासवर्ड सेट करें ताकि आप किसी भी डिवाइस पर साइन इन कर सकें। ईमेल वैकल्पिक है और खाता वापस पाने में मदद करता है।',
  'onboard.bonus.pending': 'आपके स्वागत बोनस की जाँच हो रही है, यह जल्द ही मिल जाएगा।',
  'onboard.tutorial.body': 'एक मिनट से कम में बुनियादी बातें सीखें, या सीधे खेलना शुरू करें।',
  'auth.identifier': 'यूज़रनेम या ईमेल',
  'auth.email': 'ईमेल (वैकल्पिक)',
  'auth.referral': 'रेफ़रल कोड (वैकल्पिक)',
  'auth.phone': 'फ़ोन नंबर',
  'auth.sendCode': 'कोड भेजें',
  'auth.code': '6 अंकों का कोड',
  'auth.verify': 'सत्यापित करें',
  'auth.usePhone': 'फ़ोन नंबर से',
  'auth.usePassword': 'यूज़रनेम और पासवर्ड से',
  'auth.noAccount': 'नए हैं? खाता बनाएँ',
  'lobby.events': 'इवेंट',
  'lobby.tournaments': 'टूर्नामेंट',
  'lobby.tables': '{n} टेबल',
  'lobby.entry': 'एंट्री {min}–{max}',
  'lobby.continueGame': 'आपका एक गेम चल रहा है',
  'tables.buyIn': 'बाय-इन',
  'tables.minBalance': 'न्यूनतम बैलेंस {n}',
  'tables.players': '{min}–{max} खिलाड़ी',
  'tables.timer': '{n} सेकंड की बारी',
  'tables.cantAfford': '{n} चाहिए',
  'mm.waited': '{s} सेकंड से खोज रहे हैं',
  'mm.failed': 'वह टेबल शुरू नहीं हो सकी।',
  'table.leaveConfirm': 'यह टेबल छोड़ें?',
  'table.leaveMatchWarn': 'मैच बॉट के साथ जारी रहेगा और आपकी एंट्री ज़ब्त हो जाएगी।',
  'table.leaveSessionWarn': 'बचे हुए चिप्स आपके वॉलेट में लौट जाएँगे।',
  'table.waitingPlayers': 'खिलाड़ियों का इंतज़ार…',
  'offline.title': 'आप ऑफ़लाइन हैं',
  'offline.body': 'आप अब भी अपने सामान्य टेबलों पर बॉट्स के खिलाफ़ हर खेल खेल सकते हैं। ऑनलाइन होते ही आपके सिक्के, XP और आँकड़े अपडेट हो जाएँगे।',
  'offline.tile': 'ऑफ़लाइन खेलें',
  'offline.play': 'ऑफ़लाइन खेलें',
  'offline.pending': '{n} ऑफ़लाइन खेल ऑनलाइन होते ही जुड़ जाएँगे।',
  'table.autoPlay': 'ऑटो-प्ले चालू है',
  'table.hand': 'हाथ #{n}',
  'table.pot': 'कुल पॉट',
  'install.title': 'Card Hub इंस्टॉल करें',
  'install.body': 'फुल स्क्रीन में खेलें और सीधे होम स्क्रीन से खोलें।',
  'install.button': 'इंस्टॉल करें',
  'install.later': 'अभी नहीं',
  'install.howTo': 'इंस्टॉल कैसे करें',
  'install.ios': 'ब्राउज़र में शेयर बटन दबाएँ, फिर “Add to Home Screen” चुनें।',
  'install.android': 'ब्राउज़र मेन्यू (तीन बिंदु) खोलें, फिर “Install app” या “Add to Home screen” दबाएँ।',
  'table.chat': 'चैट',
  'table.send': 'भेजें',
  'table.scores': 'स्कोर',
  'table.away': 'दूर',
  'cb.bidValue': 'कॉल {n}',
  'cb.tricks': '{won}/{bid}',
  'cb.suggested': 'सुझाव',
  'cb.playCard': 'एक पत्ता चलें',
  'tp.sideShowAsk': '{name} साइड शो माँग रहे हैं',
  'tp.accept': 'स्वीकार करें',
  'tp.decline': 'मना करें',
  'tp.stake': 'दाँव {n}',
  'tp.blindTag': 'ब्लाइंड',
  'tp.seenTag': 'देखा',
  'tp.packedTag': 'पैक',
  'pk.bet': 'बेट {n}',
  'pk.raiseTo': '{n} तक रेज़',
  'pk.halfPot': '½ पॉट',
  'pk.pot': 'पॉट',
  'pk.min': 'न्यूनतम',
  'mr.tiplu': 'टिप्लू: {card}',
  'mr.hiddenJoker': 'शो करने तक जोकर छिपा है',
  'mr.selectShow': '3 शुद्ध सीक्वेंस या टनेला चुनें',
  'mr.stock': 'स्टॉक {n}',
  'mr.autoArrange': 'अपने-आप जमाएँ',
  'results.handResult': 'हाथ का नतीजा',
  'results.place': '#{n}',
  'results.xp': '+{n} XP',
  'results.levelUp': 'लेवल अप! आप लेवल {n} पर पहुँच गए',
  'results.rating': 'रेटिंग {r} ({d})',
  'results.bonusAd': 'विज्ञापन देखें, +{n} पाएँ',
  'rooms.game': 'गेम',
  'rooms.table': 'टेबल',
  'rooms.password': 'पासवर्ड (वैकल्पिक)',
  'rooms.code': 'रूम कोड',
  'rooms.waiting': 'होस्ट के शुरू करने का इंतज़ार…',
  'rooms.members': 'खिलाड़ी ({n}/{max})',
  'rooms.lock': 'रूम लॉक करें',
  'rooms.unlock': 'रूम अनलॉक करें',
  'rooms.cancel': 'रूम बंद करें',
  'rooms.remove': 'हटाएँ',
  'rooms.join': 'रूम में जुड़ें',
  'rooms.enterCode': 'रूम कोड डालें',
  'rooms.shareText': 'Card Hub पर मेरी {game} टेबल पर आओ! कोड {code}: {url}',
  'friends.search': 'खिलाड़ी खोजें',
  'friends.requests': 'अनुरोध',
  'friends.recent': 'हाल में साथ खेले',
  'friends.empty': 'अभी कोई दोस्त नहीं। खिलाड़ी खोजें या दोस्तों को बुलाएँ!',
  'friends.inviteLink': 'अपने लिंक से बुलाएँ',
  'friends.status.idle': 'ऑनलाइन',
  'friends.status.in_game': 'गेम में',
  'friends.status.offline': 'ऑफ़लाइन',
  'friends.block': 'ब्लॉक',
  'friends.unblock': 'अनब्लॉक',
  'friends.report': 'रिपोर्ट',
  'friends.remove': 'दोस्त हटाएँ',
  'friends.requestSent': 'अनुरोध भेजा गया',
  'profile.stats': 'आँकड़े',
  'profile.winRate': 'जीत दर',
  'profile.rating': 'रेटिंग',
  'profile.achievements': 'उपलब्धियाँ',
  'profile.history': 'मैच इतिहास',
  'profile.wallet': 'वॉलेट इतिहास',
  'profile.referral': 'बुलाएँ और कमाएँ',
  'profile.editName': 'नाम बदलें',
  'settings.theme': 'थीम',
  'settings.theme.dark': 'डार्क',
  'settings.theme.light': 'लाइट',
  'settings.theme.system': 'सिस्टम',
  'settings.volume': 'मुख्य वॉल्यूम',
  'settings.haptics': 'हैप्टिक फ़ीडबैक',
  'settings.graphics': 'ग्राफ़िक्स गुणवत्ता',
  'settings.reducedMotion': 'एनिमेशन कम करें',
  'settings.highContrast': 'हाई कंट्रास्ट',
  'settings.fontSize': 'अक्षर का आकार',
  'settings.colorBlind': 'चार रंगों की ताश (कलर-ब्लाइंड अनुकूल)',
  'settings.notifications': 'सूचनाएँ',
  'settings.privacy': 'गोपनीयता',
  'settings.showOnline': 'मेरा ऑनलाइन होना दिखाएँ',
  'settings.allowRequests': 'दोस्ती के अनुरोध की अनुमति दें',
  'settings.leaderboards': 'मुझे लीडरबोर्ड पर दिखाएँ',
  'settings.analytics': 'अनाम उपयोग डेटा साझा करें',
  'settings.account': 'खाता',
  'settings.export': 'मेरा डेटा डाउनलोड करें',
  'settings.delete': 'खाता हटाएँ',
  'settings.deleteConfirm': 'इससे आपका खाता हमेशा के लिए हट जाएगा। पुष्टि के लिए DELETE टाइप करें।',
  'settings.help': 'सहायता और FAQ',
  'notif.friendRequests': 'दोस्ती के अनुरोध',
  'notif.gameInvites': 'गेम निमंत्रण',
  'notif.dailyReward': 'दैनिक इनाम',
  'notif.missions': 'मिशन और उपलब्धियाँ',
  'notif.tournaments': 'टूर्नामेंट',
  'notif.yourTurn': 'आपकी बारी',
  'notif.promotions': 'ऑफ़र और इवेंट',
  'notif.empty': 'सब देख लिया।',
  'notif.markAll': 'सभी को पढ़ा हुआ करें',
  'daily.comeBack': 'कल फिर आएँ',
  'missions.daily': 'दैनिक',
  'missions.weekly': 'साप्ताहिक',
  'missions.resets': '{time} में रीसेट',
  'store.buy': 'खरीदें',
  'store.disabled': 'अभी खरीदारी उपलब्ध नहीं है।',
  'store.note': 'सिक्के केवल मनोरंजन के लिए हैं और इन्हें नकद में नहीं बदला जा सकता।',
  'store.freeCoins': 'मुफ़्त सिक्के',
  'ads.watch': 'एक छोटा वीडियो देखें',
  'ads.reward': '{n} सिक्के कमाएँ',
  'ads.playing': 'विज्ञापन चल रहा है… {s} सेकंड',
  'ads.limit': 'दैनिक सीमा पूरी हुई',
  'ads.credited': '+{n} सिक्के जोड़े गए!',
  'lb.daily': 'आज',
  'lb.weekly': 'सप्ताह',
  'lb.monthly': 'महीना',
  'lb.allTime': 'अब तक',
  'lb.wins': 'जीत',
  'lb.xp': 'XP',
  'lb.games': 'गेम',
  'lb.coins': 'जीते सिक्के',
  'lb.all': 'सभी गेम',
  'lb.you': 'आप: #{rank}',
  'lb.empty': 'इस अवधि में अभी कोई स्कोर नहीं। बोर्ड पर आने के लिए एक गेम खेलें!',
  'tut.next': 'आगे',
  'tut.practice': 'बॉट के साथ अभ्यास',
  'tut.replay': 'ट्यूटोरियल फिर देखें',
  'help.title': 'सहायता और FAQ',
  'report.title': 'खिलाड़ी की रिपोर्ट करें',
  'report.reason': 'कारण',
  'report.details': 'विवरण (वैकल्पिक)',
  'report.submit': 'रिपोर्ट भेजें',
  'report.thanks': 'धन्यवाद — हमारे मॉडरेटर इसकी समीक्षा करेंगे।',
  'settings.security': 'सुरक्षा',
  'mfa.title': 'टू-फ़ैक्टर ऑथेंटिकेशन',
  'mfa.onBody': 'चालू — साइन इन के लिए ऑथेंटिकेटर ऐप का कोड ज़रूरी है।',
  'mfa.offBody': 'ऑथेंटिकेटर ऐप से अपना खाता सुरक्षित करें। स्टाफ़ के लिए अनिवार्य।',
  'mfa.setup': 'सेट अप करें',
  'mfa.scan': 'Google Authenticator, Microsoft Authenticator या 1Password से स्कैन करें, फिर 6 अंकों का कोड डालें।',
  'mfa.enable': 'चालू करें',
  'mfa.disable': 'बंद करें',
  'mfa.enabled': 'टू-फ़ैक्टर ऑथेंटिकेशन चालू हो गया',
  'mfa.disabled': 'टू-फ़ैक्टर ऑथेंटिकेशन बंद हो गया',
  'mfa.code': 'ऑथेंटिकेटर कोड',
  'mfa.loginHint': 'इस खाते पर टू-फ़ैक्टर ऑथेंटिकेशन चालू है।',
  'mfa.qr': 'ऑथेंटिकेटर QR कोड',
  'replay.title': 'रीप्ले',
  'replay.watch': 'रीप्ले देखें',
  'replay.controls': 'रीप्ले नियंत्रण',
  'replay.start': 'शुरुआत पर जाएँ',
  'replay.prev': 'पिछला चरण',
  'replay.next': 'अगला चरण',
  'replay.play': 'चलाएँ',
  'replay.pause': 'रोकें',
  'replay.position': 'रीप्ले स्थिति',
  'replay.step': 'चरण {n} / {total}',
  'replay.speed': 'प्लेबैक गति',
  'watch.title': 'लाइव देखें',
  'watch.cta': 'देखें',
  'watch.banner': 'देख रहे हैं — पत्ते छिपे रहते हैं',
  'cosmetics.title': 'कार्ड बैक और टेबल',
  'cosmetics.cardBack': 'कार्ड बैक',
  'cosmetics.felt': 'टेबल का रंग',
  'cosmetics.locked': 'लेवल {n} पर खुलेगा',
  'cosmetics.back.classic': 'क्लासिक',
  'cosmetics.back.crimson': 'लाल',
  'cosmetics.back.midnight': 'आधी रात',
  'cosmetics.back.saffron': 'केसरिया',
  'cosmetics.back.himalaya': 'हिमालय',
  'cosmetics.back.gold': 'सुनहरा',
  'cosmetics.felt.emerald': 'पन्ना',
  'cosmetics.felt.royal': 'शाही नीला',
  'cosmetics.felt.maroon': 'मैरून',
  'cosmetics.felt.charcoal': 'चारकोल',
  'cosmetics.felt.teal': 'टील',
  'theme.toLight': 'लाइट मोड पर जाएँ',
  'theme.toDark': 'डार्क मोड पर जाएँ',
  'cb.yourCall': 'आपकी कॉल',
  'cb.moreBids': '9 से 13 दिखाएँ',
};
